<template>
    <ProductDetailBuyBox />
</template>
